import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { setUser } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = loc.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { nav("/login", { replace: true }); return; }
    const session_id = match[1];

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        setUser(data.user);
        toast.success(`Welcome, ${data.user.name}!`);
        window.history.replaceState({}, "", "/");
        nav(data.user.role === "admin" ? "/admin" : "/account", { replace: true });
      } catch (e) {
        toast.error("Sign-in failed. Please try again.");
        nav("/login", { replace: true });
      }
    })();
  }, []); // eslint-disable-line

  return (
    <div className="pt-40 min-h-screen text-center text-slate-500">
      <div className="text-4xl text-[#D4AF37] animate-pulse">✦</div>
      <div className="mt-4">Signing you in...</div>
    </div>
  );
}
